(() => {
  'use strict';
  const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  function initLogoOrbit(){
    document.querySelectorAll('[data-testid="header-logo"]').forEach(logo => {
      if (logo.querySelector('.aury-logo-orbit')) return;
      const orbit = document.createElement('span');
      orbit.className = 'aury-logo-orbit';
      orbit.setAttribute('aria-hidden','true');
      orbit.innerHTML = '<i class="aury-logo-orbit__ring"></i><i class="aury-logo-orbit__ring"></i>' +
        '<i class="aury-logo-orbit__node"></i>'.repeat(4);
      logo.appendChild(orbit);
    });
  }

  function initButtonPulse(){
    if (reduce) return;
    document.addEventListener('pointerdown', e => {
      const target = e.target.closest('a,button');
      if (!target || target.closest('[data-testid="header-logo"]')) return;
      const pulse = document.createElement('span');
      pulse.className = 'aury-frequency-click';
      pulse.style.left = `${e.clientX}px`;
      pulse.style.top = `${e.clientY}px`;
      document.body.appendChild(pulse);
      pulse.addEventListener('animationend', () => pulse.remove(), {once:true});
    }, {passive:true});
  }

  function launchThanksParticles(root){
    if (!root || reduce || root.dataset.particlesStarted === '1') return;
    root.dataset.particlesStarted = '1';
    const field = root.querySelector('.aury-thanks__field');
    if (!field) return;
    const symbols = ['Hz','∿','·','⌁'];
    for(let i=0;i<32;i++){
      const p = document.createElement('span');
      const molecule = i % 4 === 0;
      p.className = `aury-particle${molecule ? ' aury-particle--molecule' : ''}`;
      if (!molecule) p.textContent = symbols[i % symbols.length];
      const angle = (Math.PI * 2 * i / 32) + (Math.random()-.5)*.35;
      const dist = 170 + Math.random()*430;
      p.style.setProperty('--x', `${Math.cos(angle)*dist}px`);
      p.style.setProperty('--y', `${Math.sin(angle)*dist}px`);
      p.style.setProperty('--r', `${-80+Math.random()*160}deg`);
      p.style.setProperty('--dur', `${2.2+Math.random()*1.8}s`);
      p.style.setProperty('--size', `${10+Math.random()*8}px`);
      p.style.animationDelay = `${Math.random()*.7}s`;
      field.appendChild(p);
      p.addEventListener('animationend',()=>p.remove(),{once:true});
    }
  }

  function init(){
    initLogoOrbit();
    initButtonPulse();
    document.querySelectorAll('[data-aury-thanks]').forEach(launchThanksParticles);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
